import React, { useEffect, useState } from "react";
import { Form, Input, Radio, Select, Modal, Button, Checkbox } from "antd";
// import style from "./list.module.sass";

import "./import-function.scss";
import { useSelector } from "react-redux";

import { ReactComponent as Import } from "../../../../assets/svg/MarketplaceFunctions/Vector.svg";
import { ImportInstalledFunction } from "./importInstalledFunction";
import { FunctionCategories } from "./FunctionCategories";
import { Spinner } from "../../../../helpers/commonUi/Spinner";
import { useToast } from '../../../../helpers/commonFunction';
import { AppState } from "../../../../stateManager/store";
import { useParams } from "react-router-dom";
import { Http } from "../../../../helpers/axois";
import { logger } from "../../../../constant/winston";
const { Option } = Select;

const allCatagories: any = ["Functions", "Installed Functions"]

export const ImportFunction: React.FC<any> = ({ handleUpdateList, funcList }): JSX.Element => {
  const [visible, setVisible] = useState<any>({
    visible: false,
    type: "Imports",
  });
  const [activeTab, setActiveTab] = useState<any>('Functions');
  const [selectedFunc, setSelectedFunc] = useState<any>({});
  const [funcName, setFuncName] = useState<string>("");
  const [funcIdentifier, setIdentifier] = useState<string>("");
  const [funcExecution, setFuncExecution] = useState<string>("");
  const [functionData, setFunctionData] = useState<any>([]);
  const [isPublic, setIsPublic] = useState<boolean>(false);
  const getCreatedUser = useSelector((state: any) => state.user.data);
  const params: any = useParams();
  const appId = params.appId;
  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const versionId: any = useSelector((state: AppState) => state.apps.appVersion[appId] && state.apps.appVersion[appId].versionId);
  const currentBranchId: any = useSelector((state: AppState) => state.apps.appBranch[appId] && state.apps.appBranch[appId].branchId);
  const { ErrorToast, SuccessToast } = useToast();
  const isSoloapp = useSelector((state:AppState)=>state.apps.selectedApp && state.apps.selectedApp.type === "a8solo");
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  
  const getFilteredFunctions = () => {
    if (activeTab === "Installed Functions") {
      return functionData.filter(({ is_installed }: any) => is_installed);
    }
    return functionData;
  };

  const onClick = (value: any) => {
    setActiveTab(value);
  };

  const showModal = (): void => {
    setVisible({ visible: true, type: "Imports" });
  };

  const handleCancel = (): void => {
    setVisible({ visible: false, type: "Imports" });
  };

  const handleOk = (): void => {
    setVisible({ visible: false, type: "Imports" });
  };

  const handleImport = (): void => {
    if (!orgPermissions?.includes("marketplace.PublishFunc") && loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Error fetching marketplace functions")
      return
    } 
    Http.get(
      `/orgs/${orgId}/marketplaceFunctions/${selectedFunc.id}`
    ).subscribe((res: any) => {
      const { source, permissions, com_source, current_version_id, mode } = res.data
      const data: any = {
        name: funcIdentifier,
        displayName: funcName,
        appId,
        versionId,
        isPublic: isPublic,
        language: "javascript",
        executionMode: mode,
        branchId: currentBranchId,
        source,
        comSource: com_source,
        permissions,
        marketplaceFunctionVersion: current_version_id,
        msg: "Marketplace functions"
      };
      Http.post(`/orgs/${orgId}/marketplaceFunctions/import/${selectedFunc.id}`, data).subscribe(
        (res) => {
          const createdby: any = Object.values(getCreatedUser).find((obj: any) => {
            return obj.id === res.data.createdBy
          });
          const name = createdby.userName 
          setVisible({ visible: false, type: "Import" });
          handleUpdateList([{ ...res.data, createdBy: name }, ...funcList]);
          SuccessToast("Function imported");
        },
        (err) => {
          if (err.message.includes("already exists")) {
            ErrorToast("Function with this name already exists");
          }
        }
      );
    }, (err) => {
      if (err === "Forbidden") {
        ErrorToast("Not Authorized: Error fetching marketplace functions")
      }
    });
  }

  useEffect(() => {
    if (visible.visible) {
      if ((!orgPermissions?.includes("marketplace.PublishFunc") || !orgPermissions.includes('org.View'))&& loggedInUserId!=selectedOrg?.owner) {
        ErrorToast("Not Authorized: Error fetching marketplace functions")
        return
      } 
      Http.get(
        `/orgs/${orgId}/marketplaceFunctions`
      ).subscribe((res: any) => {
        if (res) {
          setFunctionData(res.data);
        }
      }, (e) => {
        if (e === "Forbidden") {
          ErrorToast("Not Authorized: Error fetching marketplace functions")
        }
        logger.error(e);
      });
    }
  }, [orgId, visible.visible]);

  useEffect(() => {
    //setting the default value of the selected function
    setFuncName(selectedFunc.name);
    setIdentifier(selectedFunc.name);
    setFuncExecution(selectedFunc.mode);
  }, [selectedFunc])
  
  if (!functionData) {
    return (
      <Spinner />
    )
  }

  return (
    <div title="Import Function" className="function-import">
      <Import data-test-id="show_modal" height="25px" width="25px" onClick={showModal} />
      {visible.type === "Imports" ?
        <Modal
          className="override-modal"
          width="1115px"
          title="IMPORT FUNCTIONS"
          visible={visible.visible}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
        >
          <div className="widget-import-header">
            <FunctionCategories
              data-test-id="categories"
              onClick={onClick}
              activeTab={activeTab}
              allCatagories={allCatagories}
            />
          </div>
          <ImportInstalledFunction
            activeTab={activeTab}
            functions={getFilteredFunctions()}
            setVisible={setVisible}
            setSelectedFunc={setSelectedFunc}
          />
        </Modal>

        :
        <Modal
          className="override-modal"
          title={`IMPORT ${selectedFunc.name}`}
          visible={visible.visible}
          onCancel={() => {
            setVisible({ visible: false, type: "Import" });
          }}
          footer={[
            <div className="importfunc-footer" key="">
              <Button type="default" className="cancel" onClick={() => setVisible({ visible: false, type: "Import" })}>
                Cancel
              </Button>
              <Button type="primary" className="submit" onClick={handleImport}>
                Import
              </Button>
            </div>,
          ]}
        >
          {selectedFunc && (
            <Form className={"override-content"}>
              <Form.Item
                label={<span className="labelName">Display Name</span>}
              >
                <Input
                  value={funcName}
                  onChange={(e) =>{
                    const re = /^[A-Za-z_][A-Za-z0-9,_/;'"!&@%$-\s]*$/;                             ;
                    if (e.target.value === '' || re.test(e.target.value)) {
                      let val =  e.target.value.replace(/[^a-zA-Z0-9_ ]/g, "") 
                      let value =  val.replace(/ /g,"_") 
                     setFuncName(e.target.value)
                     setIdentifier(value)
                    }}
                    }
                />
              </Form.Item>
              <Form.Item
                label={<span className="labelName">Name(identifier)</span>}
              >
                <Input
                  data-test-id="function_name"
                  value={funcIdentifier}
                  onChange={(e) =>{
                    const re = /^[A-Za-z_][A-Za-z0-9_]*$/;
                                if (e.target.value === '' || re.test(e.target.value)) {
                     setIdentifier(e.target.value)}}}
                />
              </Form.Item>
              <Form.Item label={<span className="labelName">Execution Type</span>}>
                <Radio.Group disabled={true} value={funcExecution} onChange={(e) => setFuncExecution(e.target.value)}>
                  <Radio data-test-id="client" value={"client"}>
                    <span>Client</span>
                  </Radio>
                  <Radio data-test-id="server" value={"server"}>
                    <span>Server</span>
                  </Radio>
                </Radio.Group>
              </Form.Item>
              {isSoloapp &&
                <Form.Item>
                  <div className="row" style={{ marginLeft: '-15px', marginRight: '-15px', marginTop: '8px' }}>
                    <div className={"col-md-6"}>
                      <Checkbox
                        data-test-id="isPublic"
                        disabled={true}
                        checked={isPublic}
                        onChange={e => setIsPublic(e.target.checked)}
                      > Public </Checkbox>
                    </div>
                  </div>
                </Form.Item>
              }
              <Form.Item label={<span className="labelName">Language</span>}>
                <Select data-test-id="language" value={"javascript"} disabled={true} >
                  <Option data-test-id="javascript" value="javascript">JavaScript</Option>
                  <Option data-test-id="typescript" value="typescript">TypeScript</Option>
                </Select>
              </Form.Item>
            </Form>)}
        </Modal>
      }
    </div>
  );
};

